import React from "react";
import "../../../css/WhyChooseUs.css";
import { ReactComponent as PremiumIcon } from "../../../assets/icons/PremiumIcon.svg";
import { ReactComponent as PeaceIcon } from "../../../assets/icons/PeaceIcon.svg";
import { ReactComponent as TaxIcon } from "../../../assets/icons/TaxIcon.svg";
import { ReactComponent as ProvidersIcon } from "../../../assets/icons/TrustedProviderIcon.svg";
import { ReactComponent as AffordabilityIcon } from "../../../assets/icons/AffordabilityIcon.svg";
import { ReactComponent as CapitalProtectionIcon } from "../../../assets/icons/CapitalProtectionIcon.svg";
import { ReactComponent as CostIcon } from "../../../assets/icons/CostEfficientIcon.svg";
import { ReactComponent as FutureIcon } from "../../../assets/icons/FutureIcon.svg";
import { ReactComponent as FutureProofIcon } from "../../../assets/icons/FutureIcon.svg";

const features = [
  {
    icon: <PremiumIcon />,
    title: "Premiums Guaranteed",
    text: "Fixed premiums no surprises",
  },
  {
    icon: <PeaceIcon />,
    title: "Peace of Mind",
    text: "Relax, we’ve got you covered",
  },
  {
    icon: <TaxIcon />,
    title: "Tax Free",
    text: "Benefits are paid free of income tax, NI and IHT, no tax to pay",
  },
  {
    icon: <ProvidersIcon />,
    title: "Trusted Providers",
    text: "FCA approved",
  },
  {
    icon: <AffordabilityIcon />,
    title: "Affordability",
    text: "Best value compared to current alternatives",
  },
  {
    icon: <CapitalProtectionIcon />,
    title: "Capital Protection",
    text: "Allowing resources to be reallocated as required",
  },
  {
    icon: <CostIcon />,
    title: "Cost Efficient",
    text: "Only pay for the cover you need",
  },
  {
    icon: <FutureProofIcon />,
    title: "Future Proof",
    text: "Cover increases to reflect rises in school fees",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="plan section-bg section-bg--blue">
      <div className="why-choose-us__container">
        <h4>WHY CHOOSE US</h4>
        <div className="divider" />
        <div className="content">
          Our clients trust us not because we sell insurance, but because we{" "}
          <span className="content-medium accent">
            protect what matters most.
          </span>
        </div>

        <div className="why-choose-us__grid">
          {features.map((item, index) => (
            <div className="why-choose-us__card" key={index}>
              <div className="why-choose-us__icon">{item.icon}</div>
              <div className="body-medium">{item.title}</div>
              <div className="body">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
